















































import { Component, Vue } from "vue-property-decorator";
import mdui from "mdui";

@Component
export default class userInfo extends Vue {
  private flag: number = 0;
  private mduiLogin: any = null;
  constructor() {
    super();
  }

  get showFlag(): number {
    return this.$store.state.token ? 1 : 0;
  }

  get userName(): string {
    return this.$store.state.userName ? this.$store.state.userName : "请登录";
  }

  public openLogin(flag: number) {
    this.$store.commit("openLogin", flag);
  }

  public clear() {
    mdui.dialog({
      title: "提醒",
      content: "强制刷新，将清除本地所有用户资料和缓存",
      buttons: [
        {
          text: "取消",
        },
        {
          text: "确认",
          onClick: function (inst) {
            inst.close();
            setTimeout(() => {
              // 插入 meta 标签
              let oMeta: any = document.createElement("meta");
              oMeta.httpEquiv = "pragma";
              oMeta.content = "no-cache";
              document.getElementsByTagName("head")[0].appendChild(oMeta);
              let b: any = document.createElement("meta");
              b.httpEquiv = "Cache-Control";
              b.content = "no-cache, must-revalidate";
              document.getElementsByTagName("head")[0].appendChild(b);
              let c: any = document.createElement("meta");
              c.httpEquiv = "refresh";
              c.content = "1";
              document.getElementsByTagName("head")[0].appendChild(c);
              localStorage.clear(); //清除缓存
            }, 100);
          },
        },
      ],
    });
  }
  public logout() {
    mdui.dialog({
      title: "退出登录",
      content: "确定退出登录，将清除本地所有用户资料",
      buttons: [
        {
          text: "取消",
        },
        {
          text: "确认",
          onClick: function (inst) {
            inst.close();
            setTimeout(() => {
              localStorage.clear(); //清除缓存
              window.location.reload(); //刷新页面
            }, 100);
          },
        },
      ],
    });
  }
}
